import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { UnpaidInvoicesPayPortalPage } from '../../../../../components/pages/unpaid-invoices-recovery/unpaid-invoices-pay-portal-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

const searchSchema = type({ invoices: 'string[]' })

export const Route = createFileRoute('/(customer)/_portal/unpaid-invoices/payment')({
  validateSearch: searchSchema,
  component: function Component() {
    const { invoices } = Route.useSearch()
    return (
      <PermissionChecker requiredPermissions={['invoice.pay']}>
        <UnpaidInvoicesPayPortalPage invoices={invoices} />
      </PermissionChecker>
    )
  },
})
